<template>
    <div>
        <template v-if="! loading">
            <b-row>
                <div class="col-12">
                    <b-card>
                        <b-card-title title-tag="h5" :title="`Open Games (${games.length})`"></b-card-title>
                        <b-card-body>
                            <div id="open-table"></div>
                        </b-card-body>
                    </b-card>
                </div>
            </b-row>
        </template>
    </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        gamesRaw: {
            default: false,
        },
    },
    data() {
        return {
            games: [],
            loading: false,
            table: false,
            loader: false,
        };
    },
    methods: {
        buildTable() {
            this.table = new Tabulator("#open-table", {
                data: this.games,
                layout: "fitColumns",
                columns: [
                    { title: "Game", field: "title", headerFilter: "input" },
                    { title: "site", field: "site" },
                    { title: "Start Time", field: "start_time", formatter: (cell) => {
                        // Format the date to DD/MM/YYYY HH:MM convert the time from UTC to user's timezone
                        return moment(cell.getValue()).tz('Europe/London').format('DD/MM/YYYY HH:mm');
                    }},
                    { title: 'Bookings', field: 'bookings', formatter: (cell) => {
                        let row = cell.getRow().getData();
                        return `${cell.getValue()}/${row.slots}`;
                    }},
                    { title: "Actions", field: "id", formatter: (cell) => {
                        return `<a href="${this.$routes.route('game.show', {game: cell.getValue()})}" target="_blank" class="btn btn-primary">View</a>`;
                    }},
                ],
            });
        },
        loadGames() {
            axios.get(this.$routes.route('game.openGames', {getData: true}))
                .then((response) => {
                    this.games = response.data;
                    this.table.replaceData(this.games);
                    // this.buildTable();
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        init() {
            this.games = this.gamesRaw;
            this.loading = false;
            setTimeout(this.buildTable, 100);

            // this.loader = setInterval(this.loadGames, 5 * 1000);
            this.loader = setInterval(this.loadGames, 60 * 1000);
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>